import { computed } from 'vue'

import { MAX_RATING } from '../../constants'

export const useRatingDetailsDots = (rate: number) => ({
  nbEmptyDots: computed(() => Math.max(0, Math.floor(MAX_RATING - rate))),
  nbFullDots: computed(() => Math.floor(rate)),
  displayHalfDot: computed(() => !Number.isInteger(rate)),
})
